import './style.css';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Canvas } from '@react-three/fiber';
import Experience from './Experience.jsx';
import { BrowserView, MobileView } from 'react-device-detect';
import { useEffect, useState } from 'react';
import * as THREE from 'three';

import { auth } from './firebase-config';
import { signOut } from 'firebase/auth'; 
import { onAuthStateChanged } from 'firebase/auth';
import Login from './Login.jsx';
import AdminPanel from './AdminPanel.jsx';
import Salle1 from './Salle_1/salle_1.jsx'; 
import Salle2 from './Salle_2/salle_2.jsx'; 


const Layout = ({ children, user, isAdmin, showAdminPanel, setShowAdminPanel }) => (
  <>
    Site ferme
  </>
);

const App = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAdminPanel, setShowAdminPanel] = useState(false);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (u) => {
        setUser(u);
        setIsAdmin(u?.email === 'paulmarechal785@hotmail.fr');
    });
    return () => unsubscribe();
  }, []);

  if (!user) return <Login onLogin={() => {}} />;

  return (
    <>
        Site ferme
    </>
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
